import { type Meta } from '../types/docs';
import { AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user toggles whether an automation is enabled',
  name: 'automation_enabled_changed',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation whose enabled state changed',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The new enabled state',
      name: 'enabled',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
